module.exports = __webpack_public_path__ + "img/white-used-car.70f73d57.jpg";